import _ from "lodash";
import { router } from "@inertiajs/react";

export const navigateBackAndReload = () => {
  window.addEventListener(
    "popstate",
    (event) => {
      event.stopImmediatePropagation();
      router.visit(window.location.href, {
        replace: true,
        preserveScroll: true,
        preserveState: false,
      });
    },
    { once: true },
  );
  window.history.back();
};

// If this returns true (i.e. the user clicked a link on the sidebar/bottom navigation, or the tab/app opened directly to this page),
// then we will show the top and bottom navbars on the Calendar page
// If it returns false (e.g. the user clicked a link on the Clients page, Conversations page, Connect page, or anywhere else),
// then we will hide navigation and show a Back button on the Calendar page
export const getReferredFromNav = () => {
  return (
    // We were referred from sidebar/bottom navigation
    new URLSearchParams(window.location.search).get("from_nav") === "true" ||
    getReferredFromSignIn()
  );
};

export const getReferredFromSignIn = () => {
  return (
    // There is no known referrer, which means the user opened this tab from a bookmark,
    // or navigated directly, or the mobile app has just launched on this page
    // (In this case, we probably want the user to see the navbar in their Calendar page)
    (!window?.sessionStorage?.getItem("inertia-referrer-href") &&
      (!document?.referrer || document.referrer.indexOf("sign_in") !== -1)) ||
    // Fallback
    false
  );
};

export const clearNavigationReferrer = () => {
  window?.sessionStorage?.removeItem("inertia-referrer-href");
};

export const highestZIndexOfElementType = (elements) => {
  const highestZIndexElement = _.maxBy(
    Array.prototype.slice.call(elements),
    (e) => Number(e.style.zIndex),
  );
  return Number(highestZIndexElement.style.zIndex);
};

export const isMacPlatform = /mac/i.test(navigator.platform);

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent,
);

export const youtubeRegexMatcher = new RegExp(
  /https?:\/\/(?:(?:www|m)\.)?youtube\.com(\/watch)?\?v=([\w\-_]*)(?:(?![.?!;](?:\s|$))[-a-zA-Z0-9@:;%._\+~#=&\?\/])*/gi,
); // will match https://www.youtube.com/watch?v=u5643U3qS8g plus additional URL parameters
export const shortYoutubeRegexMatcher = new RegExp(
  /https?:\/\/(?:(?:www|m)\.)?(?:youtu\.be|youtube\.com\/shorts)\/([^"&?\/ ]{11})(?:\?(?:(?![.?!;](?:\s|$))[-a-zA-Z0-9@:;%._\+~#=&\?\/])*)?/gi,
); // will match https://youtu.be/u5643U3qS8g or https://youtube.com/shorts/u5643U3qS8g

export const vimeoRegexMatcher = new RegExp(
  /https?:\/\/(?:www\.)?vimeo\.com\/(\d+(?:\/[\da-z]+)?)(?:[\?#](?:(?![.?!;\/](?:\s|$))[-a-zA-Z0-9@:;%._\+~#=&\?])*)?/gi,
);
export const vimeoPlayerRegexMatcher = new RegExp(
  /https?:\/\/(?:www\.)?(?:player\.)vimeo\.com\/(?:video\/)(\d+(?:\/[\da-z]+)?)(?:[\?#](?:(?![.?!;\/](?:\s|$))[-a-zA-Z0-9@:;%._\+~#=&\?])*)?/gi,
);

// Matches Instagram post, reel, and IGTV URLs
// Formats: instagram.com/p/ABC123/, instagram.com/reel/ABC123/, instagram.com/tv/ABC123/
export const instagramRegexMatcher = new RegExp(
  /https?:\/\/(?:www\.)?instagram\.com\/(?:p|reel|tv)\/([\w-]+)\/?(?:\?[^\s]*)?/gi,
);

export const stringToFile = (uri, filename) => {
  const link = document.createElement("a");
  document.body.appendChild(link); // Firefox requires the link to be in the body
  link.download = filename;
  link.href = uri;
  link.click();
  document.body.removeChild(link); // remove the link when done
};

export const isValidEmail = (email = "") => {
  let re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(email);
};
